import { Badge } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

export const NotificationButton = ({ count }: { count?: number }) => {
  const showBadge = !!count && count > 0;

  const bellIcon = (
    <FontAwesomeIcon icon={faBell} />
  );

  return showBadge ? (
    <Badge count={count} size="small" offset={[-2, 2]}>
      {bellIcon}
    </Badge>
  ) : bellIcon;
};

